import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import companies from "../../services/companies.js";

class TransactionhistoryController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout
  ) {
    $localStorage.activeStateName = "invoices";
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }
    this.name = "transactionhistory";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.currentPageNumber = 1;
    this.$common = CommonService;
    this.fakeReceipts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.isPrivate = false;
    this.isPreferred = false;
    this.uiViews = {};
    this.uiViews.is_loading = true;
    this.receipts = [];
    this.remain_loading_count = 1;
    this.event = {};
    this.teamsPostedTo = [];
    this.acceptedApplicants = [];
    this.currentUser = this.$auth.getUserData();
    this.fileTypeId = null;
    this.events = [];
    var _this = this;

    //_this.getClosedJobs();
    _this.getCompanyPFDFileType();

    _this.$timeout(function () {
      $("jobbleheader .main-menu ul li:nth-child(3)").removeClass().addClass("active");
    }, 300);
  }

  formatPaymentCost(receipts) {
    var _this = this;
    receipts.forEach(function (receipt, index) {
      if (receipt.payment) {
        receipt.adjustedAmount = (receipt.payment[0].amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct)) / 100;
      } else {
        receipts.splice(index, 1);
      }
    });
  }

  formatRecDate(date) {
    return moment(date).format("MM/DD/YY");
  }

  paginate(offset) {
    var _this = this;
    _this.remain_loading_count++;
    let params = {};
    params.isClosed = "true";
    params.companyId = _this.currentUser.company.id;
    params.max = 20;
    params.sort = "dateCreated";
    params.order = "desc";
    if (offset < 1 || offset > _this.pages.length) {
      return;
    }
    _this.currentPageNumber = offset;
    if (offset !== 0) {
      offset = offset * 20 - 20;
    }
    params.offset = offset;
    _this.getClosedJobs(params);
  }

  getClosedJobs(data) {
    console.log("getClosedJobs");
    var _this = this;

    let params = {};
    if (!data) {
      params.companyId = _this.currentUser.company.id;
      params.isClosed = "true";
      params.max = 20;
      params.sort = "dateCreated";
      params.order = "desc";
    } else {
      params = data;
    }
    _this.setLoader();

    _this.$events.get_history(params).then(
      function (response) {
        _this.remain_loading_count--;
        _this.events = response.data;
        _this.unSetLoader();
        _this.setPages();
      },
      function (error) {
        _this.remain_loading_count--;
      }
    );
    params.offset = 0;
  }

  setPages() {
    var _this = this;

    if (_this.currentUser.company.totalNumberOfCloseEvents) {
      var pageArray = [];

      for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfCloseEvents / 20); i++) {
        pageArray.push(i + 1);
        _this.pages = pageArray;
      }
    }
  }

  setLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  initializeToolTip() {
    this.$timeout(() => {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 500);
  }

  constructCustomNote(note) {
    let secondCustomNote = null;
    let index = note.indexOf("event:");
    console.log("each index");
    console.dir(index);

    if (index === -1) {
      console.log("wat is index1");
      secondCustomNote = note;
    } else {
      console.log("wat is index2");
      index = index + 7;
      console.dir(index);
      let customNote = note.substring(index, note.length);
      console.dir(customNote);
      let secondIndex = customNote.indexOf("at the event:");

      if (secondIndex !== -1) {
        secondIndex = secondIndex - 2;
        console.log("what is second index");
        console.dir(secondIndex);
        secondCustomNote = customNote.substring(0, secondIndex);
      } else {
        secondCustomNote = customNote;
      }
    }

    console.log("what is custom note");
    console.dir(secondCustomNote);

    return secondCustomNote;
  }

  processReceipts(receipts) {
    var _this = this;

    try {
      receipts.forEach(function (r) {
        console.log("each receipt");
        console.dir(r.payedUser[0].email);
        console.dir(r.payment[0].detailTransactionCompany);

        r.paymentDate = moment(r.dateCreated).format("MM/DD/YYYY");
        r.email = r.payedUser[0].email;
        r.firstName = r.payedUser[0].firstName;
        r.lastName = r.payedUser[0].lastName;
        r.customNote = _this.constructCustomNote(r.payment[0].detailTransactionCompany);
        if (r.customNote.length > 68) {
          r.customNoteShort = r.customNote.substring(0, 68);
        } else {
          r.customNoteShort = r.customNote;
        }
        r.note = r.payment[0].detailTransactionCompany.substring(0, 90);
        r.noteLong = r.payment[0].detailTransactionCompany;
        r.charge = numeral(r.payment[0].amountCompany / 100).format("$0,0.00");
        r.url = r.url;
        _this.receipts.push(r);
      });
    } catch (err) {
      console.error(err);
    } finally {
      console.log("in the finally");
      console.dir(receipts);
      console.dir(this.receipts);
      //this.receipts = receipts;
      //this.receipts.concat(receipts);
      _this.initializeToolTip();
      _this.unSetLoader();
      _this.uiViews.is_loading = false;
    }
  }

  paginateReceipts() {
    console.log("paginateReceipts");
    if (this.currentUser.company.totalNumberOfInvoiceFiles === this.receipts.length) {
      return;
    }

    this.getReceipts(15, this.fileTypeId, this.receipts.length);
  }

  getReceipts(max, fileTypeId, offset) {
    console.log("getReceipts");
    this.setLoader();

    this.$companies
      .getDirectPaymentReceipts(max, fileTypeId, offset)
      .then((response) => {
        console.log("receipts response");
        console.dir(response);
        if (response.data) {
          this.processReceipts(response.data);
        } else {
          alert("Issue generating receipts");
        }
      })
      .catch((err) => {
        console.error("Error retrieving file types", err);
      });
  }

  getCompanyPFDFileType() {
    let fileTypeId = null;
    this.uiViews.is_loading = true;
    this.$companies
      .fileTypesReq()
      .then((response) => {
        try {
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].name === "COMPANY_INVOICE_PDF") {
              fileTypeId = response.data[i].id;
              this.fileTypeId = fileTypeId;
            }
          }
        } catch (err) {
          this.uiViews.is_loading = false;
          alert("Error getting file type: " + err);
        } finally {
          if (fileTypeId) {
            this.getReceipts(15, fileTypeId, 0);
          } else {
            this.uiViews.is_loading = false;
          }
        }
      })
      .catch((err) => {
        console.error("Error retrieving file types: ", err);
      });
  }

  checkForMoreReceipts() {
    let res = null;

    if (this.currentUser.company.totalNumberOfInvoiceFiles === this.receipts.length) {
      res = true;
    } else {
      res = false;
    }

    return res;
  }
}

TransactionhistoryController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
];

export default TransactionhistoryController;



// WEBPACK FOOTER //
// ./client/app/components/transactionhistory/transactionhistory.controller.js